// extracted by mini-css-extract-plugin
module.exports = {"openinapp":"VMt6u","show-sticky":"OV21Q"};